const target = (label, table, endpointKey, fallbackEndpoint) => ({
  label, table, endpointKey, fallbackEndpoint,
})

const catalog = {
  BC_PEDIDOS_EXPEDICIONES_SYNC: [
    target('Pedidos', 'nav.pedidos_cabecera', 'cabeceraEndpoint'),
    target('Líneas de pedido', 'nav.pedidos_lineas', 'lineasEndpoint'),
    target('Expediciones', 'nav.expedicion_cabecera', 'cabeceraEndpoint'),
    target('Líneas de expedición', 'nav.expedicion_lineas', 'lineasEndpoint'),
    target('Envases de expedición', 'nav.expedicion_envases', 'lineasEndpoint'),
  ],
  BC_LOGISTICS_CLIENTES_DESTINOS_SYNC: [
    target('Clientes', 'logistics.clientes', 'clientesEndpoint'),
    target('Destinos', 'logistics.customer_destinations', 'destinosEndpoint'),
  ],
  BC_LOGISTICS_PROVEEDORES_ALMACENES_SYNC: [
    target('Proveedores', 'logistics.proveedores', 'proveedoresEndpoint'),
    target('Almacenes de proveedor', 'logistics.provider_warehouses', 'almacenesEndpoint'),
  ],
  BC_LOGISTICS_TRANSPORTISTAS_SYNC: [
    target('Transportistas', 'logistics.transportistas', 'transportistasEndpoint'),
  ],
  BC_EXPEDITION_BILLING_MASTERS_SYNC: [
    target('Variedades', 'nav.varieties', 'variedadesEndpoint'),
    target('Calibres', 'nav.calibres', 'calibresEndpoint'),
    target('Confecciones', 'nav.confecciones', 'confeccionesEndpoint'),
    target('Envases', 'nav.envases', 'envasesEndpoint'),
    target('Palets', 'nav.palets', 'paletsEndpoint', 'JciPaletsSuite'),
    target('Materiales', 'nav.listado_materiales', 'materialesEndpoint', 'JciListadoMateriales'),
    target('Firmas de producto', 'nav.product_signatures'),
  ],
}

export const hasIntegrationRunner = (code) => Object.prototype.hasOwnProperty.call(catalog, code)

export const getIntegrationTargets = (integration) => {
  const configuration = integration?.configuration || {}
  const endpoints = configuration.endpoints || {}
  return (catalog[integration?.code] || []).map((item) => ({
    ...item,
    endpoint: item.endpointKey
      ? configuration[item.endpointKey] || endpoints[item.endpointKey] || item.fallbackEndpoint || integration.endpoint || ''
      : '',
  }))
}
